import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base class for components wanting rx helpers
 *
 * Note: the @Directive is added to prevent warnings from angular
 * its not actually used as since we are only using it to extend actual
 * components.
 */
@Directive()
export class RXComponent implements OnDestroy {
  destroy$ = new Subject<undefined>();

  ngOnDestroy() {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }
}
